import { Component, OnInit, Input } from '@angular/core';
import { BaseComponentService } from '../../../services/base-component.service';
import { FormControl, FormGroup } from '@angular/forms';
import { TipoContaBancaria } from '../../../shared/enum/shared.enum';
import { LiquidacaoEnvio } from '../../../models/pagamento/liquidacao-envio';
import { ProcessadoLiqEmpenhoComponent } from '../liq-empenho/processado/processado-liq-empenho.component';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { Consignataria } from '../../../models/pagamento/consignataria';
import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'gpa-liq-complemento',
  templateUrl: './liq-complemento.component.html',
  providers: [BaseComponentService],
})
export class LiqComplementoComponent extends BaseComponentService implements OnInit {
 
  @Input() liquidacaoEnvio: LiquidacaoEnvio;
  
  subscription: Subscription;

  complementoForm: FormGroup;

  dadosComplementaresLiq: LiquidacaoEnvio;
  
  vigenciaContaCredor: Date;
  tipoContaCredor: TipoContaBancaria;
  vigenciaContaConsignataria: Date;
  codigoCredorConsignataria: number;
  consignatariaLegal: boolean;

  consignatarias: Consignataria[] = [];
  

  ngOnInit() {
    this.getDetalheLig(
      this.liquidacaoEnvio.codigoProjeto,
      this.liquidacaoEnvio.anoExercicio, 
      this.liquidacaoEnvio.numeroObservacao
      );

    this.criarFormulario();
  
  }

  /*
  * Retorna a máscara de CPF ou CNPJ do credor de acordo com o tamanho da string.
  */
  getCpfCnpjMask(controle: string) {
    const cpfMask = '000.000.000-00';
    const cnpjMask = '00.000.000/0000-00';
    
    const valor = this.complementoForm.get(controle).value;

    if (valor.length === 11) {
        return cpfMask;
    } else if (valor.length === 14) {
        return cnpjMask;
    } else if (valor.length === 10) {
        this.atualizarControle('cnpjCpfConsignataria', ("00000000000" + valor).slice(-11));
        return cpfMask;
    }
    else {
      return '';
    }
  }

  criarFormulario() {
    this.complementoForm = this.fb.group({
      bancoCredor: this.fb.control({value: '', disabled: true}),
      agenciaCredor: this.fb.control({value: '', disabled: true}),
      contaCredor: this.fb.control({value: '', disabled: true}),
      tipoContaCredor: this.fb.control({value: '', disabled: true}),
      formaRecebimento: this.fb.control({value: '', disabled: true}),
       subelemento: this.fb.control({value: '', disabled: true}),
      valorSubelemento: this.fb.control({value: '', disabled: true})
    });
  }

  atualizarFormulario() {
    this.atualizarControle('bancoCredor', this.dadosComplementaresLiq.codigoBancoCredor != null
      ? ("0000" + this.dadosComplementaresLiq.codigoBancoCredor).slice(-3) +"-"+ this.dadosComplementaresLiq.nomeBancoCredor : "-");
    
    this.atualizarControle('agenciaCredor', this.dadosComplementaresLiq.codigoAgenciaCredor != null
      ?this.dadosComplementaresLiq.codigoAgenciaCredor : "-");
    
    this.atualizarControle('contaCredor', this.concatContaDigito(
      this.dadosComplementaresLiq.numeroContaBancariaCredor, this.dadosComplementaresLiq.digitoContaBancariaCredor));
    
    this.atualizarControle('tipoContaCredor', this.isNullOrUndefined(this.dadosComplementaresLiq.tipoContaCredor)
      ? '-' : TipoContaBancaria[this.dadosComplementaresLiq.tipoContaCredor.toString()]);
    
   this.atualizarControle('formaRecebimento', this.dadosComplementaresLiq.nomeFormaRecebimentoCredor != null
      ? this.dadosComplementaresLiq.nomeFormaRecebimentoCredor : "-");
    
     this.atualizarControle('subelemento', this.dadosComplementaresLiq.codigoSubElementoFormatado !=null 
      ? this.dadosComplementaresLiq.codigoSubElementoFormatado : "-");
    
    this.atualizarControle('valorSubelemento', this.dadosComplementaresLiq.valorSubElementoDespesa);    
  }



  concatContaDigito(conta: number, digito: string): string {
    return !this.isNullOrUndefined(conta) ? conta.toString().concat('-').concat(digito) : '-';
  }

  // Atualiza o conteúdo do controle verificando a nulidade do futuro conteúdo.
  atualizarControle(controle: string, value: any) {
    this.complementoForm.get(controle).setValue(value === null || value === undefined ? '' : value.toString());      
  }

  getNomeFormaRecebimento(codForma: number): Observable<string> {
    this._service.routePrefix = `/api/FormaRecebimento/Obter/${codForma}`;
  
    return this._service.getById(null, 'gpa').pipe(
      map((formaRecebimento: any) => formaRecebimento.nome)
    );
  }

  cancelarOnClick() {
    ProcessadoLiqEmpenhoComponent.updateList.next('');
  }

  // Retorna o credor por código. É chamado no método para retorno do credor na consignatária.
  async getDetalheLig(codigoProjeto: string, anoExercicio:number, numObservacao:string): Promise<void> {
    
    this.aslibLoadingService.start();
    this._service.routePrefix = '/api/LiqEnvio/ObterDadosComplementares/'.concat(
      `${codigoProjeto.trim()}` ).concat('/').concat(`${anoExercicio}`).concat('/').concat(`${numObservacao}`);

    
    this.subscription = this._service.getAll('gpa').pipe(
        tap(data => {
          this.dadosComplementaresLiq = data;
          this.atualizarFormulario();
          this.consignatarias = data.consignatarias;
        }),
        finalize(() => this.aslibLoadingService.complete())
      ).subscribe({
        error: error => {
          this.cancelarOnClick();
          const msgErro = error.error[Object.keys(error.error)[0]];
          this.exibirAlerta(msgErro);
        }
      });

  }

}






// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-complemento/liq-complemento.component.ts